import { Link } from "@tanstack/react-router";

/**
 * TopSelling list item component.
 *
 * Displays a top selling author/creator in a list format.
 * Shows:
 * - Author rank number (NumImg) or avatar
 * - Author avatar image
 * - Author name link
 * - Category/specialty link
 * - Earnings/volume display
 *
 * @param {Object} props - Component props
 * @param {string} props.path1 - Link to author profile/avatar
 * @param {string|number} props.NumImg - Rank number displayed in badge
 * @param {string} props.img - Author avatar URL
 * @param {string} props.path2 - Link to author name
 * @param {string} props.text1 - Author display name
 * @param {string} props.path3 - Link to author category/specialty
 * @param {string} props.text2 - Category/tag text
 * @param {string|number} props.price - Sales volume/earnings in SGB
 * @returns {React.ReactElement} Top seller list item
 */
function TopSelling({path1 , NumImg , img , path2 , text1 , path3 , text2 , price}){
  return(
      <li className="list-group-item border-0 d-flex align-items-center px-0 mb-2">
        <Link to={path1} className="avatar v2 me-3">
          <span className="author-num">{NumImg}</span>
          <img src={img} alt="kal" className="border-radius-lg shadow" />
        </Link>
        <div className="d-flex align-items-start flex-column justify-content-center">
          <Link to={path2}><h6 className="author-name">{text1}</h6></Link>
          <Link className="btn btn-link autho-link" to={path3}>{text2}</Link>
        </div>
        <span className="auth-earning ms-auto">{price} SGB</span>
      </li>
  )
}

export default TopSelling